import React, { Component } from 'react';
import { Link, Switch, Route, Redirect } from 'react-router-dom'
import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Breadcrumb from '../../components/Breadcrumb/';
import Aside from '../../components/Aside/';
import Footer from '../../components/Footer/';
import Users from '../../views/users/usuarios'
import Account from '../../views/account/cuenta'
import Stores from '../../views/stores/stores'
import Dashboard from '../../views/dashBoard/dashBoard'
import Data from '../../views/data/data'
import Forms from '../../views/forms/listForm'
import FormView from '../../views/forms/FormView'
import FormEdit from '../../views/forms/editForm'
import HistoryList from '../../views/history/historyList'
import Dataset from '../../views/datasets/datasets'
import { withRouter } from "react-router-dom";
import Firebase from 'firebase';
import Administracion from '../../views/administracion/main'
import MockUp from '../../views/dashBoard/mockUp'
import Haiti from '../../views/cafe-haiti/main'
import Control from '../../views/control_de_asistencia/main'

class Full extends Component {

  constructor(props) {
    super(props);
    this.state = {
      login: true
    };
  }

  componentDidMount() {
    const contex = this;
    var userRef = Firebase.auth().onAuthStateChanged(user => {
      if (!user && !localStorage.client_id) {
        contex.props.history.push("/login");
      } else {
        if (!localStorage.verified) {
          var adminRef = Firebase.database().ref("admin_ref/" + userRef.uid + "/verified").on("value", snap => {
            if (!snap.val()) {
              contex.props.history.push("/register");
            }
          });
        }
      }
    })
  }
  render() {
    return (
      <div className="app" style={{ overflow: "hidden" }}>
        <Header />
        <div className="app-body">
          <Sidebar {...this.props} />
          <main className="main">
            <Breadcrumb />
            <div className="container-fluid">
              <Switch>
                <Route path="/locales" name="locales" component={Stores} />
                <Route path="/formularios" name="formularios" component={Forms} />
                <Route path="/vista/:formId" name="view" component={FormView} />
                <Route path="/editor/:formId" name="view" component={FormEdit} />
                <Route path="/registros" name="registros" component={Data} />
                <Route path="/usuarios" name="usuarios" component={Users} />
                <Route path="/cuenta" name="cuenta" component={Account} />
                <Route path="/control" name="Control de Asistencia" component={Control} />
                <Route path="/historial" name="historial" component={HistoryList} />
                <Route path="/set-de-datos" name="datasets" component={Dataset} />
                <Route path="/graficas" name="graficas" component={Dashboard} />
                <Route path="/dashboard" name="graficas" component={MockUp} />
                <Route path="/haiti" name="graficas" component={Haiti} />
                <Route path="/administracion" name="Administracion" component={Administracion} />
                <Redirect from="/" to="/cuenta" />
              </Switch>
            </div>
          </main>
          <Aside />
        </div>
        <Footer />
      </div>
    );
  }
}

export default Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js